import React, { useEffect, useState } from 'react'
import Api from '../../../../../services/Api'
import BaseActivity from '../../Base/Activity/BaseActivity'
import { IActivityDetail } from '../../Default/Activity/IActivityDetail'
import NFTImageSkeleton from '../../../components/NFTImageSkeleton'
import { IAvaxCatsCard } from '../Card/IAvaxCatsCard'
import { getTokenUri } from '../../../../../services/NFTMarketPlace/Graphquery'

export default function AvaxCatsActivityDetail({ collection, historyItem, chainId }: IActivityDetail) {
  const { tokenId } = historyItem
  const [tokenUri, setTokenUri] = useState('')
  const [detailTokenItem, setDetailTokenItem] = useState<IAvaxCatsCard | null>(null)

  useEffect(() => {
    if (tokenId !== undefined && tokenId !== null && !tokenUri) {
      getTokenUri(collection.tokenAddress, tokenId).then(res => setTokenUri(res))
    }
    if (tokenUri) {
      Api.get(tokenUri).then((tokenResult: any) => setDetailTokenItem(tokenResult))
    }
  }, [tokenUri, collection.tokenAddress, tokenId])

  const tokenName = detailTokenItem ? detailTokenItem.name : collection.name

  return (
    <BaseActivity chainId={chainId} historyItem={historyItem} collection={collection} tokenName={tokenName}>
      {detailTokenItem ? <img src={detailTokenItem.image.replace('gateway.pinata.cloud', 'ipfs.io')} alt={detailTokenItem.name} /> : <NFTImageSkeleton />}
    </BaseActivity>
  )
}